module.exports = __webpack_public_path__ + "static/media/undraw_empty_xct9.a71020bd.svg";